import styled from "styled-components";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const AlarmSimpleOkBox = ({ title, description, handleClickX }) => {
  return (
    <Box>
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "20px" }}>
          {title}
        </p>
      </div>
      <div className="hrz-wrapper center" style={{ marginTop: "10px" }}>
        <p
          style={{
            color: "#222222",
            textAlign: "center",
            whiteSpace: "pre-line",
            lineHeight: "1.5",
          }}
        >
          {description}
        </p>
      </div>

      <div
        className="blueBtn-base center"
        style={{
          margin: "30px auto 0",
          width: "400px",
          height: "60px",
          borderRadius: "10px",
          fontFamily: "notoSans-medium",
        }}
        onClick={handleClickX}
      >
        확인
      </div>
    </Box>
  );
};

const AlarmSimpleOk = ({ title, description, handleClickX }) => {
  return (
    <LayoutModal
      Modal={
        <AlarmSimpleOkBox
          title={title}
          description={description}
          handleClickX={handleClickX}
        />
      }
    />
  );
};

const Box = styled.div`
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

export default AlarmSimpleOk;
